<template>
    <!-- Footer start -->
    <div class="bg-secondary w-full flex justify-center items-center md:justify-evenly flex-col md:flex-row gap-8 p-8">
        <!-- Overview start -->
        <div class="text-stone-100 text-center">
            <img src="@/assets/logo-long-white.png" alt="img" class="md:w-1/2">
        </div>
        <!-- Overview end -->

        <!-- Links start -->
        <div class="text-white flex flex-col items-center gap-4">
            <div class="flex justify-center items-center gap-8">
                <a :href="footer.instagram" target="_blank" rel="noopener noreferrer">
                    <i class="fa-brands fa-instagram socialIcon transition"></i>
                </a>
                <a :href="footer.linkedin" target="_blank" rel="noopener noreferrer">
                    <i class="fa-brands fa-facebook socialIcon transition"></i>
                </a>
            </div>
            <p class="text-sm text-stone-100 opacity-75">
                © {{ currentYear }} Dark Pollen. All rights reserved.
            </p>
        </div>
        <!-- Links end -->
    </div>
    <!-- Footer end -->
</template>

<script>
import { contentfulClient } from '@/config/contentful'

export default {
    name: 'FooterElement',
    data() {
        return {
            footer: {
                instagram: 'https://www.instagram.com/darkpollen/', // Default value
                linkedin: 'https://www.linkedin.com/in/emily-bongelli-a02743119/' // Default value
            },
            currentYear: new Date().getFullYear()
        }
    },
    async created() {
        try {
            const response = await contentfulClient.getEntries({
                content_type: 'footer',
                limit: 1
            })
            
            if (response.items && response.items.length > 0 && response.items[0].fields) {
                this.footer = response.items[0].fields
            }
        } catch (error) {
            console.error('Error fetching footer content:', error)
        }
    }
}
</script>

<style>

</style>